import { liftFromInlineNode, LiftFromInlineNodeOptions } from '@common/prosemirror/commands/lift-from-inline-node.command';
import { wrapInInlineNode, WrapInlineNodeOptions } from '@common/prosemirror/commands/wrap-in-inline-node.command';
import { containsInlineNode } from '@common/prosemirror/model/node-find';
import { NodeType } from 'prosemirror-model';
import { Command, EditorState } from 'prosemirror-state';

export type ToggleInlineNodeOptions = WrapInlineNodeOptions & LiftFromInlineNodeOptions;

/**
 * Toggles an inline node by either wrapping the selection or lifting it out of the inline node.
 * @param nodeType The node type to toggle.
 * @param options The options for the command.
 * @returns The command.
 */
export function toggleInlineNode(nodeType: NodeType, options?: ToggleInlineNodeOptions): Command {
  const wrap = wrapInInlineNode(nodeType, options);
  const lift = liftFromInlineNode(nodeType, options);

  return function (state: EditorState, dispatch?: ProsemirrorDispatcher): boolean {
    // If the selection is directly inside the inline node THEN lift the selection out of the inline node
    if (containsInlineNode(state.selection.from, state.selection.to, nodeType, state.doc)) {
      return lift(state, dispatch);
    }
    // Else wrap the selection in the inline node
    else {
      return wrap(state, dispatch);
    }
  };
}
